import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { calculateGoalProgress } from '../../pages/dashboardHelpers';

const ProgressBar = ({ label, current, target, percent, color }) => (
    <div style={{ marginBottom: '12px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', fontFamily: 'Montserrat', fontSize: '12px' }}>
            <span style={{ fontWeight: 600, color: '#333' }}>{label}</span>
            <span style={{ color: '#666' }}>{current} / {target}</span>
        </div>
        <div style={{ backgroundColor: '#e9ecef', borderRadius: '8px', height: '10px', overflow: 'hidden' }}>
            <div style={{
                width: `${percent}%`,
                height: '100%',
                backgroundColor: percent >= 100 ? '#28a745' : color,
                borderRadius: '8px',
                transition: 'width 0.3s ease'
            }} />
        </div>
    </div>
);

const GoalProgress = observer(({ assessments, companyStore }) => {
    const goals = companyStore?.company?.practiceGoals;

    const progress = useMemo(() => {
        if (!goals || (!goals.weeklyTarget && !goals.monthlyTarget)) return null;
        return calculateGoalProgress(assessments || [], goals);
    }, [assessments, goals?.weeklyTarget, goals?.monthlyTarget]);

    if (!progress) return null;

    return (
        <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '20px',
            border: '1px solid #e0e0e0',
            marginBottom: '20px'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '15px' }}>
                <span style={{ fontSize: '18px' }}>🎯</span>
                <span style={{ fontFamily: 'Montserrat', fontWeight: 600, fontSize: '16px', color: '#333' }}>
                    Practice Goals
                </span>
                {progress.isOnTrack && (
                    <span style={{
                        backgroundColor: '#d4edda', color: '#155724',
                        padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: 600
                    }}>
                        On Track
                    </span>
                )}
            </div>

            {progress.weeklyTarget > 0 && (
                <ProgressBar
                    label="This Week"
                    current={progress.weeklyProgress}
                    target={progress.weeklyTarget}
                    percent={progress.weeklyPercent}
                    color="#137fa2"
                />
            )}
            {progress.monthlyTarget > 0 && (
                <ProgressBar
                    label="This Month"
                    current={progress.monthlyProgress}
                    target={progress.monthlyTarget}
                    percent={progress.monthlyPercent}
                    color="#6f42c1"
                />
            )}
        </div>
    );
});

export default GoalProgress;
